const TRANSLATION_ES = {
    analytics: 'Analítica',
    getDeeperInsights: 'Obtener mas información',
    thisCanTakeAwhile: 'Esto puede tomar un tiempo',
    Display: 'Mostrar',
    Regular: 'Regular',
    Primary: 'Primeros años',
    chooseDataRange: 'Seleccionar rango de datos',
    barView: 'Gráfica de barras',
    'Emotion distribution for selected period': 'Distribución de emociones para el periodo de tiempo seleccionado',
    gender: 'Género',
    male: 'Hombre',
    female: 'Mujer',
    percentageOfResponseDistributionByGender: 'Porcentaje de distribución de respuesta por género',
    general: 'General',
    'Total response percentage': 'Porcentaje total de respuestas',
    'Engagement with emotions': 'Interacción con emociones',
    'Total emotions submitted': 'Total de emociones',
    emotion: 'Emoción',
    'No. of emotions': 'Número de emociones',
    mostCommonReasons: 'Razones más comunes',
    noResults: 'Sin resultados',
    'Track trends': 'Seguimiento de tendencias',
    'Add a new trend': 'Añadir una nueva tendencia',
    searchQuestion: 'Buscar pregunta',
    clickToSeeQuestionInDetails: 'Hacer clic para ver la pregunta a detalle',
    'Remove from trends': 'Eliminar de tendencias',
    schedule: 'Calendario',
    on: 'Encender',
    On: 'Encender',
    Off: 'Apagar',
    doYouWantToDeleteThis: '¿Quieres borrar esto?',
    'Time frame': 'Periodo de tiempo',
    howAreYouToday: '¿Cómo te encuentras hoy?',
    getDeeperInsightsIntoYourStudentsEmotionalTrends: 'Obtener conocimientos profundos sobre las conductas emocionales de tus estudiantes',
    getInsights: 'Información detallada',
    'General Engagement': 'Interacción general',
    'Overall engagement': 'Interacción general',
    'Engagement with content': 'Interacción con el contenido',
    Registration: 'Registro',
    'Registered teachers': 'Maestros registrados',
    registeredStudents: 'Estudiantes registrados',
    'Content has been removed from trends': 'El contenido ha sido eliminado de las tendencias',
    By: 'Por',
    Target: 'Objetivo',
    delete: 'Borrar',
    download: 'Descargar',
    searchStudents: 'Buscar resultados',
    'Select surveys': 'Seleccionar encuestas',
    answers: 'Respuestas',
    getBackToMainAnalytics: 'Volver a las analíticas generales',
    'Student engagement with content': 'Interacción de los estudiantes con el contenido',
    name: 'Nombre',
    email: 'Correo electrónico',
    class: 'Grupo',
    Class: 'Grupo',
    studentsWhoDidntRespondToAnyQuestionInPastTwoWeeks: 'Estudiantes que no respondieron a ninguna pregunta en las pasadas dos semanas',
    studentsNotFound: 'No se encontraron estudiantes',
    showMoreStudents: 'Mostrar mas resultados',
    lastLogin: 'Último ingreso',
    neverLoggedIn: 'Nunca ingresó',
    loggedInRecently: 'Ingresó recientemente',
    searchTeachers: 'Buscar maestros',
    position: 'Posición',
    teachersNotfound: 'No se encontraron  maestros',
    showMoreTeachers: 'Mostrar mas profesores',
    'Student check in': 'Revisiones de estudiantes',
    'Create Reports': 'Crear reportes',
    'Report format': 'Formato de reporte',
    Raw: 'Crudo',
    'Output fields': 'Información a mostrar',
    'Target users': 'Objetivo',
    'Create report': 'Crear reporte',
    'Return to Analytics': 'Regresar a analíticas',
    'Create & Manage Reports': 'Crear y gestionar reportes',
    'Select report dates': 'Seleccionar fechas de reporte',
    'Start date:': 'Fecha de inicio:',
    endDate: 'Fecha de terminación',
    'End date:': 'Fecha de terminación',
    search: 'Buscar',
    Date: 'Fecha',
    action: 'Acción',
    'No reports have been created yet': 'Todavía no se han creado reportes',
    'In process': 'En proceso',
    'Welcome! Create your first report here': '¡Bienvenido! Crea tu primer reporte aquí',
    'Latest reports': 'Últimos reportes',
    'View More': 'Ver mas',
    newPassword: 'Nueva contraseña',
    passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol:
        'La contraseña debe contener más de 8 caracteres, debe contener mayúsculas, minúsculas y caracteres especiales',
    password: 'Contraseña',
    youMustFillData: 'Debes ingresar datos',
    repeatPassword: 'Repite la contraseña',
    passwordsDoNotMatch: 'La contraseña no coincide',
    submitNewPassword: 'Ingresa la nueva contraseña',
    staffLogin: 'Ingreso de personal',
    enterCredentialsYouReceivedFromSchool: 'Ingresa las credenciales que recibiste de la escuela',
    login: 'Iniciar sesión',
    forgotPassword: 'Olvidaste tu contraseña?',
    requestNewPassword: 'Solicitar nueva contraseña',
    enterYourSchoolEmailAndWeWillSendYouALinkToGetBackIntoYourAccount: 'Ingresa tu correo institucional y te enviaremos un token de validación para reingresar a tu cuenta',
    sendRequest: 'envía solicitud',
    verifyYourEmail: 'verifica tu correo',
    weHaveSentYouALinkToGetBackIntoYourAccountAndCheckYourMailAndCopyYourTokenHere:
        'Te hemos enviado un token de validación para reingresar a tu cuenta. Revisa tu correo y copia tu token aquí',
    token: 'Token',
    submit: 'Enviar',
    didntGetAMail: '¿No recibiste un correo?',
    resendARequest: 'Reenviar solicitud',
    filterIsNotSet: '¡No se ha establecido el filtro!',
    commentHasBeenSeen: '¡El comentario ha sido enviado!',
    catchUp: 'Ponte al día',
    catchUpOnAnyStudentCommentsAttachedTo:
        'Ponte al día con cualquier comentario relacionado con emociones desagradables expresadas por los alumnos que pudieran haberse quedado olvidadas',
    unseen: 'Sin ver',
    archive: 'Historial',
    filter: 'Filtro',
    years: 'Grados',
    Years: 'Grados',
    all: 'Todos',
    classes: 'Grupos',
    Classes: 'Grupos',
    apply: 'Aplicar',
    markAsSeen: 'Marcar como visto',
    newMessage: 'nuevo mensaje',
    received: 'recibido',
    delivered: 'Entregado',
    counselor: 'Consejero',
    sos: 'AUXILIO',
    SOS: 'AUXILIO',
    youHaveNoChats: 'No tienes conversaciones',
    thereIsnotAnyConversationYet: 'No hay ninguna conversación aún',
    writeYourMessageHere: 'Escribe tu mensaje aquí',
    myMessage: 'Mi mensaje',
    replyOn: 'Responder en',
    'More details': 'Mas detalles',
    searchForStudent: 'Buscar un estudiante',
    searchForTeacher: 'Buscar un maestro',
    'All emotions': 'Todas las emociones',
    uncomfortable: 'Desagradables',
    filterClassroom: 'Filtrar salón de clases',
    staff: 'Equipo de trabajo',
    'Number of student who answered "How are you today?" on this date': 'Número de estudiantes que respondieron ‘¿Cómo estás hoy?’ en esta fecha',
    yourIndividualStudentsResponses: 'Respuestas individuales de tus estudiantes',
    uncomfortableEmontionsWithComments: 'Emociones desagradables con comentarios',
    year: 'Grado',
    Year: 'Grado',
    showMore: 'Mostrar más',
    showLess: 'Mostrar menos',
    wellbeingOfTeachers: 'Bienestar de los maestros',
    classroomTrends: 'Tendencias de salones de clases',
    'Comfortable Emotions': 'Emociones agradables',
    'Uncomfortable Emotions': 'Emociones desagradables',
    comment: 'comentario',
    'Your Primary Classes': 'Tus clases de primeros años',
    createYourOwnContent: 'Crear tu propio contenido',
    contentIsCreated: '¡El contenido ha sido creado!',
    contentIsNotCreated: '¡El contenido no ha sido creado!',
    yourDataIsUpdated: '¡Tus datos han sido actualizados!',
    yourDataIsNotUpdated: '¡Tus datos no han sido actualizados!',
    templateIsCreated: '¡Se ha creado la plantilla!',
    templateIsNotCreated: '¡No se ha creado la plantilla!',
    back: 'Regresar',
    createAPost: 'Crear una publicación',
    typeYourHeadlineHere: 'Escribe tu título aquí',
    addAnOptionalMessage: 'Añade un mensaje opcional',
    enterUrlLink: 'Ingresa un enlace',
    optional: '(opcional)',
    invalidLink: 'Enlace inválido',
    addPhoto: 'Añadir fotografía',
    targetGroup: 'Grupo a revisar',
    off: 'Apagar',
    saveAsTemplate: 'Guardar como plantilla',
    post: 'Publicación',
    allCreatedContent: 'Todo el contenido creado',
    options: 'Opciones',
    edit: 'Editar',
    templateIsUpdated: 'La plantilla se ha actualizado',
    'Template is updated': 'La plantilla se ha actualizado',
    addOption: 'Añadir opción',
    repeat: 'Repetir',
    addToAnalytics: 'Añadir a analíticas',
    runProgram: 'Ejecutar programa',
    select: 'Seleccionar',
    pickOneOption: 'Elige una opción',
    teachersOnly: 'Solo maestros',
    contentNeedsToBeReviewedByTheScoolAdmin: 'El contenido necesita ser revisado por el admnistrador de la Escuela',
    surveyIsCreatedAsTemplate: '¡La encuesta se ha creado como plantilla!',
    surveyIsDeleted: '¡La encuesta ha sido borrada!',
    headline: 'título',
    typeHeadlineHere: 'Escribe el título aquí',
    supportiveText: 'Texto de apoyo',
    typeAnyAdditionalTextHere: 'Escribe cualquier texto adicional aquí',
    addSection: 'Añadir selección',
    required: 'Requerido',
    anonymous: 'Anónimo',
    pleaseFillRequiredFields: 'Por favor llena los campos requeridos',
    templateIsSaved: '¡Plantilla guardada!',
    update: 'Actualización',
    publish: 'Publicar',
    section: 'Sección',
    headlineForSection: 'Título para la sección',
    descriptionForSection: 'Descripción de la sección',
    addQuestion: 'Añadir pregunta',
    question: 'Pregunta',
    moveQuestionUp: 'Mover pregunta hacia arriba',
    moveQuestionDown: 'Mover pregunta hacia abajo',
    enterQuestionHere: 'Añadir una pregunta aquí',
    selectTypeOfQuestion: 'Seleccionar tipo de pregunta',
    yesNo: 'Si/No',
    openAnswer: 'Abrir respuesta',
    Yes: 'Si',
    No: 'No',
    deleteOption: 'Eliminar opción',
    'Options must differ': 'Las opciones deben ser diferentes',
    templateDeleted: 'Plantilla eliminada',
    'No items found': 'No se encontraron elementos',
    useTemplate: 'Usar plantilla',
    fileIsToBig: '¡El archivo es demasiado grande!',
    'Cannot create anonymous poll for 1 user': 'No se puede crear un sondeo anónimo para un solo usuario',
    imageIsNotUploaded: 'La imagen no se cargó',
    enterLinkOptional: 'Ingresa el enlace aquí (opcional)',
    writeOption1Here: 'Escribe la opción 1 aquí',
    'The maximum image size for download is 1400px x 1400px': 'El tamaño máximo de imagen para descarga es 1400px x 1400px',
    addPhotoVideo: 'Añadir foto / video',
    yourBrowserDoesNotSupportHTMLVideo: 'Tu navegador no soporta videos HTML',
    addToWellbeingTracker: 'Añadir al monitor de bienestar',
    updateTemplate: 'Actualizar plantilla',
    survey: 'Encuesta',
    typeASurveyTitle: 'Escribe un título para la encuesta',
    addASurveyDescription: 'Agregar una descripción a la encuesta',
    title: 'Título',
    enterSectionTitleHere: 'Ingresa el titulo de la sección aquí...',
    description: 'Descripción',
    enterSectionDescriptionHere: 'Añadir descripción de la sección aquí',
    deleteSurvey: 'Borrar Encuesta',
    save: 'Guardar',
    doYouWantToRemoveSurvey: '¿Quieres eliminar esta encuesta?',
    createAPoll: 'Crear encuesta',
    typeAPollQuestion: 'Ingresa una pregunta para el sondeo',
    cancel: 'Cancelar',
    createAQuestion: 'Crear una pregunta',
    typeAQuestionTitle: 'Ingresa un titulo para la pregunta',
    readyToGoContent: 'Contenido listo para usar',
    sortBy: 'Filtrar por',
    type: 'Tipo',
    topic: 'Tema',
    evidenceBasedContentPreparedForYouByOurTeamOfExperts: 'Contenido basado en evidencia preparado para ti por nuestro equipo de expertos',
    manageRunningPrograms: 'Gestionar programas en ejecución',
    'Program has been deleted!': 'El programa ha sido eliminado',
    thisToolHelpsYouToControlAllRunningProgramsAndTrackTheirInfluenceToStudents:
        'Esta herramienta te ayuda a gestionar todos los programas en ejecución y a seguir su influencia en los estudiantes',
    running: 'Ejecutando',
    paused: 'Pausado',
    pauseProgram: 'pausar programa',
    playProgram: 'Iniciar programa',
    deleteProgram: 'Eliminar programa',
    yourRunningProgramListIsEmptyStartByAddingOneFromTheListOfPrograms: 'Tu lista de programas en ejecución está vacía, comienza agregando uno de la lista de programas',
    doYouWantToDeleteThisProgram: '¿Quieres eliminar este programa?',
    doYouWantToStopThisProgram: '¿Quieres detener este programa?',
    doYouWantToStartThisProgram: '¿Quieres iniciar este programa?',
    runIt: 'Implementar',
    listOfDays: 'Lista de días',
    day: 'Día',
    postIndividually: 'Publicar individualmente',
    lastCreated: 'Creado por última vez',
    surveyIsCreated: 'Se ha creado la encuesta',
    'Release survey by days': 'Liberar encuestas por días',
    configureSurvey: 'Configurar encuesta',
    editSurvey: 'Editar Encuesta',
    runSurvey: 'Implementar encuesta',
    yes: 'Si',
    no: 'No',
    currentlyRunning: 'Corriendo actualmente',
    other: 'Otro',
    wellbeingTracker: 'Monitor de bienestar',
    'Your counseling list is empty, start with adding a new counseling profile for one of your students':
        'Tu lista de consejeros esta vacía, comienza añadiendo un nuevo perfil de consejero para uno de tus estudiantes',
    reminder: 'Recordatorio',
    assignedActions: 'Acciones asignadas',
    youDontHaveAnyAssignedAction: 'Todavía no tienes acciones asignadas',
    lastNote: 'Última nota',
    Overdue: 'atrasado',
    youDontHaveAnyRemindersForToday: 'No tienes ningún recordatorio hoy',
    firstEnterANote: 'Primero ingresa una nota',
    noteIsCreated: 'La nota ha sido creada',
    reminderHasBeenChanged: '¡El recordatorio ha cambiado!',
    'Reminder has been deleted!': 'El recordatorio ha sido eliminado',
    currentEmotion: 'Emoción actual',
    mostPopularEmotion: 'Emoción mas popular',
    ofResponsesToActivePollsQuestion: '% de respuestas de preguntas de sondeos activos',
    status: 'Estatus',
    dateOfBirth: 'Fecha de nacimiento',
    teacher: 'Maestro',
    exportData: 'Exportar datos',
    notes: 'Notas',
    reminderSetFor: 'Recordatorio establecido para',
    'Stop editing': 'Detener la edición',
    editReminder: 'Editar recordatorio',
    removeReminder: 'Eliminar recordatorio',
    messageIsVisibleToAll: 'El mensaje es visible para todos',
    messageOnlyVisibleToStaffWithSpecialAccess: 'EL mensaje es visible únicamente para colaboradores con acceso especial',
    enterYourNoteHere: 'Agregar una nota',
    assignAction: 'Asignar acción',
    addNote: 'Añadir nota',
    addReminder: 'Agregar recordatorio',
    open_poll: 'Abrir sondeo',
    openQuestion: 'Abrir pregunta',
    'Assignment for': 'Tarea para',
    overview: 'Vista general',
    results: 'Resultados',
    feedPosts: 'Publicaciones de tu muro',
    myTasks: 'Mis tareas',
    contentDeleted: 'Contenido eliminado',
    displayAll: 'Mostrar todo',
    questions: 'Preguntas',
    polls: 'Sondeos',
    surveys: 'Encuestas',
    journals: 'Diarios',
    onlyMine: 'Solo mío',
    searchResults: 'Buscar resultados',
    notSelected: 'No seleccionado',
    date: 'Fecha',
    runReadyToGo: 'Aplicar contenido listo para usar',
    createContent: 'Crear contenido',
    open: 'Abierto',
    Open: 'Abierto',
    target: 'Objetivo',
    clickToBrowseResults: 'Haz clic para navegar los resultados',
    by: 'Por',
    time: 'Hora',
    from: 'De',
    to: 'A',
    createPosts: 'Crear publicaciones',
    deleteFeedContent: '¿Eliminar contenido del muro?',
    openLink: 'Abrir enlace',
    actionRequired: 'acción requerida',
    stayUpToDateWithStudentSupport: 'Ponte al día con el soporte a estudiantes',
    'Comments for review': 'comentarios por revisar',
    actionsAssignedToMe: 'Acciones asignadas a mi',
    studentChat: 'Conversación con estudiante',
    youDeletedTargetGroup: 'Eliminaste un grupo objetivo',
    deeperInsights: 'Mas información',
    effortlesslyMonitorYourStudentsEmotionalExperiencesByCreatingYourOwnCustomisedGroupsHere:
        'Monitorea sin esfuerzo las experiencias emocionales de tus estudiantes al crear tus grupos personalizados aquí',
    'Sample Group': 'Grupo de muestra',
    createGroup: 'Crear grupo',
    'Current Weekly Engagement Statistics': 'Estadísticas de uso de esta semana',
    trackEngagementResponsivenessLogins: 'Seguimiento de interacción, respuestas e ingresos a la plataforma',
    'Student logins': 'Ingresos de estudiantes',
    'Student engagement with emotions': 'Interacción de los estudiantes con las emociones',
    'Teacher logins': 'Ingresos del maestro',
    yourClassroom: 'Tu salón de clases',
    checkWhatsGoingOn: 'Revisa lo que esta pasando',
    myClassroom: 'Mi salón de clases',
    upcomingContent: 'Próximo contenido',
    yourAnswersAreSaved: '¡Tus respuestas han sido guardadas!',
    open_journal: 'Abrir diario',
    writeFullAnswerHere: 'Escribe la respuesta completa aquí',
    'Take Survey': 'Realizar encuesta',
    selectEmotionThatBestDescribesYourMoodToday: 'Selecciona una emoción que mejor describa tu estado de ánimo hoy',
    yourTasks: 'Tus tareas',
    activitiesForCompletion: 'Actividades para completar',
    Success: 'Success',
    'Thank you for helping us to make Upstrive better.': 'Gracias por ayudarnos a mejorar Upstrive',
    yourAnswerIsSaved: 'Tu respuesta ha sido guardada',
    'Click to get back to all Tasks': 'Haz clic para regresar a todas las Tareas',
    chooseTheAnswer: 'Elige una respuesta',
    'Choose the answer': 'Elige una respuesta',
    'Take it': 'Tómalo',
    open_question: 'Abrir pregunta',
    'Write the answer': 'Escribe la respuesta',
    'Type any additional text here': 'Escribe cualquier texto adicional aquí',
    yourResultsAreSaved: '¡Tus resultados se han guardado!',
    sections: 'Secciones',
    finish: 'Terminar',
    nextSection: 'Siguiente sección',
    'This day is locked!': '¡Este día esta asegurado!',
    close: 'Cerrar',
    'Finish later': 'Terminar después',
    Finish: 'Terminar',
    Next: 'Siguiente',
    selectOneOption: 'Seleccionar una opción',
    youHaveMissedThisQuestion: 'Has olvidado esta pregunta',
    welcomeBack: 'Bienvenido de regreso',
    'Here’s what happened while you were away': 'Esto es lo que ha pasado en tu ausencia',
    ofStudentsUsingHowAreYouTodayAtLeastOncePerWeek: '% de estudiantes usando "¿Cómo te sientes hoy?" por lo menos una vez por semana',
    'Not selected': 'No seleccionado',
    'Preset Ranges': 'Rangos predefinidos',
    '7 Days': '7 días',
    '1 Month': '1 Mes',
    '3 Months': '3 Meses',
    '1 Year': '1 año',
    '7d': '7d',
    '1m': '1m',
    '3m': '3m',
    '1y': '1a',
    'Select time range': 'Selecciona un rango de tiempo',
    congratsEverythingIsDoneForNowWaitForNewTasks: 'Felicidades, has terminado por ahora! Espera a recibir nuevas tareas',
    doYouWantToDeleteThisTask: '¿Quieres eliminar esta tarea?',
    doYouWantToDeletePost: '¿Quieres eliminar esta publicación?',
    dashboard: 'Panel de control',
    live: 'En vivo',
    openTasks: 'Abrir tareas',
    taskArchive: 'Archivo de tareas',
    congratulations: 'Felicidades',
    youHaveCompletedAllYourTasks: 'Has completado todas tus tareas',
    anonymous_survey: 'Encuesta anónima',
    open_survey: 'Abrir  encuesta',
    completed: 'Terminado',
    deletePost: 'Eliminar esta publicación',
    editPost: 'Editar publicación',
    submitAnswer: 'Enviar respuesta',
    classIsNotUpdated: '¡La clase no esta actualizada!',
    'Registered users': 'Usuarios registrados',
    'Unregistered users': 'Usuarios sin registrar',
    numberOfStudents: 'Numero de estudiantes',
    listOfStudents: 'Lista de estudiantes',
    addAStudent: 'Añadir un estudiante',
    loadMoreClasses: 'Cargar más grupos',
    'Are you sure you want to delete class?': 'Are you sure you want to delete class?',
    'All Student in this class will be deleted': 'All Student in this class will be deleted',
    'Class successfully deleted': 'Class successfully deleted',
    fieldIsRequired: 'Este campo es requerido',
    classIsCreated: 'El grupo está creado',
    'Type of class to create': 'Tipo de clase a crear',
    unregisteredStudents: 'Estudiantes no registrados',
    'Primary class': 'Primary class',
    cantCreateStudentWithoutCreateClass: 'Debes crear un grupo antes de agregar a un estudiante – No se puede crear un estudiante sin crear un grupo',
    loggedIn: 'Ingresado',
    Avatar: 'Avatar',
    manage: 'Gestionar',
    'Not Setuped': 'Not Setuped',
    noStudentsYet: 'No hay estudiantes todavía',
    loginStatistic: 'Estadísticas de inicio de sesión',
    reviewYourLoginStatistics: 'Revisa tus estadísticas de inicio de sesión',
    students: 'Alumnos',
    'Logged in': 'Ingresado',
    'Not logged in': 'No ingresado',
    teachers: 'Maestros',
    'Login data': 'Datos de ingreso',
    uploadUserData: 'Cargar datos de usuario',
    classManagement: 'Gestión de grupos',
    teacherManagement: 'Gestión de maestros',
    addATeacher: 'Añadir a un maestro',
    addANewClass: 'Añadir un grupo nuevo',
    'Teacher is removed!': '¡El maestro se ha eliminado!',
    'Teacher is not removed!': '¡El maestro no se ha eliminado!',
    listOfTeachers: 'Lista de maestros',
    role: 'Rol',
    noTeachersYet: 'No hay maestros aún',
    loadMore: 'Cargar más',
    fileHasBeenUploadedDataWillBeUpdatedWithin24Hours: 'El archivo se ha cargado. La información se actualizará en 24 horas',
    'File has been removed': 'File has been removed',
    downloadTemplateFile: 'Descargar archivo de plantilla',
    previousUploads: 'Cargas anteriores',
    fileLink: 'Enlace del archivo',
    attachFile: 'Adjuntar archivo',
    uploadData: 'Cargar datos',
    iWillTakeAction: 'Tomaré acción',
    describeHowYouWillDealWithThisStudent: 'Describe como vas a lidiar con este estudiante',
    writeYourThoughtsHere: 'Escribe aquí lo que piensas',
    continue: 'Continuar',
    AssignActionToATeacherToCheckOnThisStudent: 'Asignar acción al profesor para revisar a este estudiante',
    assignedTo: 'Asignado a:',
    selectTeacher: 'Seleccionar maestro',
    unreadMessage: 'mensaje sin leer',
    unreadMessage_zero: 'No hay mensajes no leídos',
    unreadMessage_one: '{{count}} mensaje no leído',
    unreadMessage_other: '{{count}} mensajes no leídos',
    assignedBy: 'Asignado por',
    className: 'Nombre del grupo',
    'Yes, Delete': 'Si, eliminar',
    'No, cancel': 'No, cancel',
    stop: 'Alto',
    archived: 'Archivado',
    thereIsntAnyAnswerYet: 'Todavía no hay respuestas',
    filterResults: 'Filtrar resultados',
    Reset: 'Restablecer',
    'Last step': 'Último paso',
    'Setup report name as your last step': 'Como último paso, establece un nombre para tu reporte',
    'Report name': 'Nombre del reporte',
    'Enter file name': 'Ingresa nombre del archivo',
    'You will be notified once your report is ready': 'Se te notificará cuando tu reporte este listo',
    saveYourFavoriteGroup: 'Guarda tu grupo favorito',
    createWellbeingProfile: 'Crea un perfil de bienestar',
    yourStudentListIsEmpty: 'Tu lista de estudiantes está vacía',
    dailyFeedback: 'Retroalimentación diaria',
    howWasYourDay: '¿Cómo estuvo tu día?',
    'We hope you’ve had a good day!': '¡Esperamos que hayas tenido un día bueno!',
    safePlaceWithDailyReflectionNotes: 'Espacio seguro con reflexiones diarias',
    whatAreJust3GoodThingsThatHappenedToday: '¿Cuáles son 3 cosas buenas que ocurrieron hoy?',
    'What are 3 things that are a bit challenging at the moment?': 'Cuáles son 3 cosas que son retadoras en este momento?',
    'What’s just one thing you will do differently tomorrow?': 'Qué cosa harías diferente mañana?',
    saveAndContinue: 'Guardar y continuar',
    iDontWantToThinkAboutThisNow: 'No quiero pensar en esto ahora',
    'Select teacher': 'Seleccionar maestro',
    actionHasBeenAssignedToTeacher: 'La acción ha sido asignada a un maestro',
    assignActionFailed: 'No se pudo asignar la acción',
    'User activity': 'Actividad de usuario',
    mood: 'Estado de ánimo',
    sendMessage: 'Enviar mensaje',
    actionTaken: 'Acción tomada',
    seenBy: 'Visto por',
    thereAreNoAnswersForThatDay: 'No hay respuestas para ese día',
    tasks: 'Tareas',
    classroomTeacher: 'Maestro de clase',
    headOfYear: 'Responsable de grupo',
    otherTeachers: 'Otros maestros',
    typeAnAction: 'Ingresa una acción',
    'Write your personal notes here': 'Escribe tus notas personales aquí',
    messageHasBeenSent: 'El mensaje ha sido enviado',
    sendPrivateMessageToStudent: 'Enviar mensaje privado a un estudiante',
    'Write personal message for the student here': 'Escribe un mensaje personal para un estudiante aquí',
    compareToLastTime: 'Comparado con la última vez',
    thisIsYourSafePlaceAndNothingWillBeShared: 'Este es tu espacio seguro. Nada será compartido',
    whatCouldYouDoToImproveThingsRightNow: '¿Qué podrías hacer para mejorar las cosas en este momento?',
    suggestions: 'Sugerencias',
    loadMoreSuggestions: 'Cargar más sugerencias',
    comparedToLastTimeTodayIamFeeling: 'Comparado a la última vez, hoy me siento',
    howDoYouFeelComparedToLastTimeYouLoggedIn: '¿Cómo te sientes en comparación a la última vez que ingresaste?',
    privateNoteHasBeenSaved: 'La nota privada ha sido guardada',
    howDoYouFeelComparedToLastTimeYouDidThePoll: '¿Cómo te sientes en comparación a la última vez que realizaste la encuesta?',
    doYouThinkThingsAreForAnyReasonInParticular: '¿Crees que las cosas están igual por alguna razón en particular?',
    enterANameForTodaysNotes: 'Elige un nombre para las notas de hoy',
    nameOfTodayNote: 'Nombre de la nota de hoy',
    yourFeedBackHasBeenSubmited: '¡Tu retroalimentación ha sido enviada!',
    iDontWantToThinkAboutItNow: 'No quiero pensar en esto ahora',
    whatIsTheMainReason: '¿Cuál es el motivo principal?',
    pickUpTo3: 'Elige hasta 3',
    myself: 'CONMIGO MISMO/A',
    family: 'Familia',
    friends: 'Amigos',
    school: 'Escuela',
    'social media': 'Redes sociales',
    wellbeing: 'bienestar',
    health: 'salud',
    achievement: 'Logros',
    sleep: 'SUEÑO',
    Myself: 'CONMIGO MISMO/A',
    Family: 'Familia',
    Friends: 'Amigos',
    School: 'Escuela',
    'Social media': 'Redes sociales',
    Wellbeing: 'bienestar',
    Health: 'salud',
    Achievement: 'Logros',
    Sleep: 'SUEÑO',
    muchWorse: 'Mucho peor',
    worse: 'Peor',
    same: 'Igual',
    better: 'Mejor',
    muchBetter: 'Mucho mejor',
    loginData: 'Datos de ingreso',
    listOfStudentsWhoHaventLoggedInYet: 'Lista de estudiantes que aún no han ingresado',
    selectAll: 'Seleccionar todo',
    'Full name': 'Nombre completo',
    noUnsignedTeachers: 'No hay maestros sin registrar',
    noUnsignedStudents: 'No hay estudiantes sin registrar',
    logout: 'Salir',
    currentPrograms: 'Programas actuales',
    createdNewMonitoringGroup: 'Nuevo grupo de monitoreo creado',
    updatedMonitoringGroup: 'Grupo de monitoreo actualizado',
    editGroup: 'Editar grupo',
    nameANewGroup: 'Nombra un nuevo grupo',
    chooseEmotions: 'Elige emociones',
    allStudents: 'Todos los alumnos',
    'all students': 'Todos los alumnos',
    '% of all students are with selected type of emotions': '% de estudiantes que experimentan las emociones seleccionadas',
    secretKeyHasBeenSaved: 'El código secreto ha sido guardado',
    staySecuredFirst: 'Primero mantente a salvo',
    Attention: 'Atención',
    toEnsureYourPrivacyThisKeyIsNotRecoverableAllYourNotesWillBeLostIfYouForgetThisKey:
        'Para asegurar tu privacidad, esta clave no es recuperable. ¡Todas tus notas se perderán si la olvidas!',
    secretKey: 'Llave secreta',
    enterSecretKey: 'ingresa las claves secretas',
    startDate: 'Fecha de inicio:',
    setATime: 'Establece una hora',
    turnOff: 'Apagar',
    deleteWasSuccessful: 'Eliminación exitosa',
    listOf: 'Lista de',
    thisListRepresentsAllContentFromThisTypeYouCanEditOrDeleteTt: 'Esta lista muestra todo el contenido de este tipo. Puedes editarlo o eliminarlo',
    editThis: 'Editar esta',
    deleteThis: 'Eliminar esta',
    created: 'Creado',
    createReminder: 'Crear recordatorio',
    'Set a date when you would like to be reminded about this student': 'Elige una fecha en la que te gustaría recibir un recordatorio sobre este estudiante.',
    'Choose a date': 'Elige una fecha',
    done: 'Hecho',
    weekly: 'Semanal',
    monthly: 'Mensual',
    selectDays: 'Seleccionar días:',
    everyMonthOn: 'Activado cada mes',
    youAreRunningThisProgramSuccessfully: 'Has implementado correctamente este programa',
    youMustSelectTargetGroup: '¡Debes seleccionar un grupo objetivo!',
    youMustSelectDaysOfWeek: '¡Debes seleccionar días de la semana!',
    thisToolHelpsYouPlanTheEntireProgramOnce: 'Esta herramienta te ayuda a planificar todo el programa de una vez para que no tengas que seguir revisándolo.',
    pickTime: 'Seleccionar hora:',
    thisProgaramIsAlreadyRunning: 'Este programa ya se esta implementando, ¿Quieres implementarlo de nuevo?',
    poll: 'Sondeo',
    feed: 'Muro',
    'This tool helps you to run a survey for your students': 'Esta herramienta te ayuda a aplicar una encuesta ppara tus alumnos',
    setupADateAndTime: 'Establece una fecha y hora',
    'Schedule Survey': 'Programar encuesta',
    "This tool helps you to schedule whole survey once so you don't need to check it all the time":
        'Esta herramienta te ayuda a programar toda la encuesta de una vez para que no necesites revisarlo todo el tiempo',
    assignToTeacher: 'Asignar a maestro',
    'Can`t create student without create class': 'No se puede crear un estudiante sin crear un grupo',
    'Data is saved': 'Datos guardados',
    emailIsInvalid: 'Correo electrónico no válido',
    emailAlreadyExists: '¡Este correo ya existe!',
    emailIsAvailable: '¡El correo esta disponible!',
    'New password is generated': 'Se ha generado la nueva contraseña',
    studentRemoved: 'Estudiante eliminado',
    studentInfo: 'Información de estudiante',
    'Transfer to another class': 'Transferir a otro grupo',
    student: 'Estudiante',
    enterStudentUPN: 'Ingresa el UPN del estudiante',
    firstName: 'Nombre',
    enterName: 'Ingresar nombre',
    lastName: 'Apellido',
    enterSurname: 'Ingresa apellido',
    enterEmail: 'Ingresa correo electrónico',
    letThemSetTheirOwnPasswordsAfterLogin: 'Permíteles establecer sus propias contraseñas después de ingresar',
    keepThisPassword: 'Mantener esta contraseña',
    hidePasswordmanager: 'Ocultar administrador de contraseña',
    setStudentsPasswordManually: 'Establecer contraseña de alumno manualmente',
    generateNewPassword: 'Generar nueva contraseña',
    closePopUp: 'Cerrar ventana emergente',
    deleteStudent: 'Eliminar estudiante',
    newPasswordHasAlreadyBeenGeneratedTodayForThisUserDoYouWantToGenerateItAgain:
        'Una nueva contraseña ya ha sido creada el día de hoy para este usuario. Quieres generarla de nuevo?',
    'New password has already been generated today for this user! Do you want to generate it again?':
        'Una nueva contraseña ya ha sido creada el día de hoy para este usuario. Quieres generarla de nuevo?',
    'You are going to generate new password for this student?': 'Estás seguro que deseas generar una nueva contraseña para este estudiante?',
    'Add student': 'Añadir estudiante',
    'Edit Student': 'Editar estudiante',
    'Change avatar': 'Change avatar',
    'Choose Gender': 'Selecciona género',
    'Choose animal': 'Elegir animal',
    'Create Student': 'Crear estudiante',
    Available: 'Available',
    Taken: 'Taken',
    'If you will choose already taken character it will auto unpin from existing child': 'If you will choose already taken character it will auto unpin from existing child',
    'Choose later': 'Choose later',
    'Save with selected avatar': 'Save with selected avatar',
    'Old class': 'Old class',
    newClass: 'Nuevo grupo',
    'New class': 'Nuevo grupo',
    selectACategory: 'Seleccionar categoría',
    favorites: 'Favorito',
    selectSpecificYearGroupsToGatherMoreInformationFrom: 'Selecciona grupos por grado específico  para obtener más información',
    'Select specific classes to gather more information from': 'Selecciona clases específicas  para obtener más información',
    customize: 'Personalizar',
    'Create your own customized group to gather information from': 'Crear tu grupo personalizado propio para obtener más información',
    'Select specific teachers you would like to get information from': 'Selecciona maestros específicos de los que quisieras obtener información',
    thereIsNoDataToShow: 'No hay información para mostrar',
    deselectAll: 'Deseleccionar todo',
    addToFavorites: 'Añadir a favoritos',
    ok: 'Ok',
    doYouWantToDeleteFavorite: '¿Quieres eliminar este grupo de favoritos?',
    'Your opinion matters to us!': '¡Tu opinión nos importa!',
    'Your feedback helps us to improve. If you find our app helpful, please consider rating it.':
        'Tu retroalimentación nos ayuda a mejorar. Si encuentras nuestra aplicación útil, por favor considera calificarla.',
    'Thank you!': '¡Gracias!',
    'Share your feedback': 'Comparte tus comentarios',
    'Leave your feedback': 'Deja tus comentarios',
    'Tell us how we can improve AlKalmaUp in the box below': 'Dinos cómo podemos mejorar AlKalmaUp en el recuadro de abajo',
    'Type your feedback here': 'Escribe tus comentarios aquí',
    rolemodelIsnotLoaded: '¡El modelo de rol no esta cargado... por favor refresca la página!',
    teacherIsCreatedAndPasswordHasBeenSent: 'El maestro ha sido creado y la contraseña ha sido enviada',
    teacherIsNotCreated: '¡El maestro no se ha creado!',
    'The new password has been sent!': 'The new password has been sent!',
    'Password delivery failed!': 'Password delivery failed!',
    teacherInfo: 'Información de maestro',
    enterTeachersDetails: 'Ingresar detalles de maestro',
    "You can't delete yourself!": '¡No te puedes eliminar a ti mismo!',
    deleteTeacher: 'Eliminar maestro',
    teacherRole: 'Rol del maestro',
    selectTeacherRole: 'Seleccionar rol del maestro',
    thisTeacherWillbe: 'Este maestro será',
    'You must select class': 'You must select class',
    'Current class': 'Grupo actual',
    'Select new class': 'Seleccionar nuevo grupo',
    'Select class': 'Seleccionar grupo',
    'Transfer to another class successfully finished': 'La transferencia a otro grupo ha finalizado exitosamente',
    runReadyToGoContent: 'Aplicar contenido listo para usar',
    assignActionSuccess: 'Acción asignada con éxito',
    userIsUpdated: 'El usuario ha sido actualizado',
    changePassword: 'Cambiar contraseña',
    enterYourNewPassword: 'Ingresa tu nueva contraseña',
    retypePassword: 'reintroducir contraseña',
    noteHasBeenDeleted: 'La nota ha sido eliminada',
    dayReview: 'Reseña del día',
    'Day review': 'Reseña del día',
    deleteNote: 'Borrar Nota',
    yourPrivateNotes: 'Tus notas privadas',
    confirmDeletion: 'Confirmar eliminación',
    deleteYourPrivateNote: '¿Borrar tus notas privadas?',
    'Language is changed': 'Se ha cambiado el idioma',
    yourSecretKeyIsSaved: 'Tu clave secreta se ha guardado',
    selectLanguage: 'Seleccionar idioma',
    termsAndConditions: 'Términos y condiciones',
    privacyPolicy: 'Política de privacidad',
    changeSecurityKey: 'Cambiar la clave de seguridad',
    createYourOwn: 'Crea tu propio contenido',
    readyToGo: 'Contenido listo para usar',
    classroom: 'Salón de clases',
    Analytics: 'Analítica',
    chat: 'Conversación',
    userManagement: 'Administración de usuario',
    instructionVideos: 'Videos instructivos',
    settings: 'Ajustes',
    'Full Desktop version': 'Versión completa de escritorio',
    'Full Mobile version': 'Versión completa para móvil',
    individualFeaturesTraining: 'Entrenamiento de características individuales',
    instructionVideosForStaff: 'Video de instrucciones para colaboradores',
    sunday: 'Domingo',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    today: 'Hoy',
    tomorrow: 'Mañana',
    yesterday: 'Ayer',
    month: 'Mes',
    months: 'Meses',
    days: 'días',
    hour: 'Hora',
    hours: 'Horas',
    minute: 'Minuto',
    minutes: 'Minutos',
    seconds: 'Segundos',
    'Multiple classes': 'Múltiples grupos',
    'Multiple years': 'Múltiples grados',
    custom: 'Personalizar',
    'Select target': 'Seleccionar objetivo',
    Filter: 'Filtro',
    Gender: 'Género',
    Grade: 'Grado',
    "Student's feedback": 'Retroalimentación del estudiante',
    "Student's comment": 'Comentarios de alumno',
    'Feedback date': 'Fecha de retroalimentación',
    "Teachers' action": 'Acción del maestro',
    Reasons: 'Motivos',
    "Student's emotion": 'Emociones del estudiante',
    happy: 'Feliz',
    ecstatic: 'Entusiasmado',
    inspired: 'Inspirado',
    calm: 'Calmado',
    lethargic: 'Aburrido',
    grumpy: 'Molesto',
    sad: 'Triste',
    stressed: 'Estresado',
    angry: 'Enojado',
    numb: 'Desganado',
    worried: 'Preocupado',
    good: 'Tranquilo',
    Happy: 'Feliz',
    Ecstatic: 'Entusiasmado',
    Inspired: 'Inspirado',
    Calm: 'Calmado',
    Lethargic: 'Aburrido',
    Grumpy: 'Molesto',
    Sad: 'Triste',
    Stressed: 'Estresado',
    Angry: 'Enojado',
    Numb: 'Desganado',
    Worried: 'Preocupado',
    Good: 'Tranquilo',
    Emotions: 'Emociones',
    excited: 'Emocionado',
    afraid: 'Temeroso',
    Excited: 'Emocionado',
    Afraid: 'Temeroso',
    'Percentage of student logins this week': 'Porcentaje de inicios de sesión de estudiantes esta semana',
    'Percentage of students engaging with content this week': 'Porcentaje de estudiantes que interactuaron con el contenido esta semana',
    'Percentage of students that submitted an emotion this week': 'Porcentaje de estudiantes que registraron una emoción esta semana',
    'Percentage of teacher logins this week': 'Porcentaje de ingresos de maestros esta semana',
    'Number of students that left a comment combined with uncomfortable emotion': 'Número de estudiantes que dejaron un comentario junto con una emoción desagradable',
    'Monitor student unease with this pre-set Sample Group': 'Monitorea el malestar de los estudiantes con este Grupo de Muestra preestablecido',
    'Percentage of students who have experienced these emotions in selected period':
        'Porcentaje de estudiantes que han experimentado estas emociones durante el período seleccionado',
    'Relative change to the same selected previous period': 'Cambio relativo respecto al mismo período anterior seleccionado',
    'Percentage of students that used Upstrive in the period (any function, just opened it)':
        'Porcentaje de estudiantes que utilizaron Upstrive en el período (cualquier función, simplemente lo abrieron)',
    'Total number of emotions submitted in the time frame': 'Número total de emociones registradas en el período de tiempo seleccionado',
    'Percent of students that submitted an emotion in the selected time frame': 'Porcentaje de estudiantes que enviaron una emoción en el periodo de tiempo seleccionado.',
    'Percentage of teachers who have registered to the app': 'Porcentaje de maestros que se han registrado en la aplicación',
    'Percentage of students who have registered to the app': 'Porcentaje de estudiantes que se han registrado en la aplicación',
    'Percentage of student check-ins this week': 'Porcentaje de estudiantes que hicieron check-in esta semana',
    'Percentage of students in your group who have registered in Upstrive': 'Porcentaje de estudiantes en tu grupo que se han registrado en Upstrive',
    'Percentage of teachers in your group who have registered in Upstrive': 'Porcentaje de maestros/maestras en tu grupo que se han registrado en Upstrive',
    'Percentage of students engaging with content in the selected time frame': 'Porcentaje de estudiantes que interactuaron con el contenido en el período de tiempo seleccionado',
    'Percentage of students that submitted an emotion in the selected time frame': 'Porcentaje de estudiantes que registraron una emoción en el período de tiempo seleccionado',
    Frequency: '',
    'Options must differ ': '',
    'Download students credentials': '',
    Never: 'Never',
    Sometimes: 'Sometimes',
    Often: 'Often',
    Always: 'Always',
    'Do not agree': 'Do not agree',
    "If you don't agree to Terms and Conditions you are not going to be allowed to use the app!":
        "If you don't agree to Terms and Conditions you are not going to be allowed to use the app!",
    'You will be logged out': 'You will be logged out',
    'I do not agree': 'I do not agree',
    Continue: 'Continue',
    "I confirm that I read and agree to Alkalma's": "I confirm that I read and agree to Alkalma's",
    'Terms and Conditions': 'Terms and Conditions',
    'Display all': 'Mostrar todo',
    Notes: 'Notas',
    Questions: 'Pregunta',
    Polls: 'Sondeos',
    'Message sent to student': 'El mensaje se ha enviado al estudiante',
    'How do you feel?': '¿Cómo te sientes?',
    selectYears: 'Selección de grados',
    selectClasses: 'Selección de grupos',
    selectStaff: 'Selección de personal',
    selectFromMyStudents: 'Seleccionar de mis estudiantes',
    selectCustom: 'Personalizado',
    multipleClasses: 'Múltiples grupos',
    multipleYears: 'Múltiples grados',
    'Remember to set up filters to get started!': 'Recuerda configurar los filtros para comenzar!',
    'Seen 6 days ago': 'Visto hace {{time}}',
    'Left 6 days ago': 'Ingresado hace {{time}}',
    'Target users': 'Objetivo',

    // todo
    '1st': '1.',
    '2nd': '2.',
    '3rd': '3.',
    '4th': '4.',
    '5th': '5.',
    '6th': '6.',
    '7th': '7.',
    '8th': '8.',
    '9th': '9.',
    '10th': '10.',
    'Action taken': 'Acción tomada',
    'Anonymous user': 'Usuario anónima',

    'Search for students': 'Buscar alumnos',
    Feeling: 'Feeling',
    'Monitor Wellbeing': 'Monitor Wellbeing',
    'Comfortable emotions since school year start': 'Comfortable emotions since school year start',
    Attention: 'Attention',

    'Last online': 'Última conexión',
    'No data found': 'No se encontraron datos',
    'This element will be updated once enough app-activity has been recorded': 'Este elemento se actualizará una vez que se haya registrado suficiente actividad en la aplicación.',
    'What u wish to do?': '¿Qué deseas hacer?',
    'Open Chat': 'Abrir conversación',
    'Assign Action': 'Asignar acción',
    'Manage Student': 'Información del alumno',

    Alerts: 'Alertas',
    'Assigned Actions': 'Acciones asignadas',

    'Participation in Activities': 'Participación en actividades',

    'Check-ins': 'Registros',
    'Take Action': 'Tomar acción',
    'Assigned to': 'Asignado a',
    'Average number of emotions submitted by student on daily basis': 'Número medio diario de emociones presentadas por los estudiantes',
    'Number of emotion submitted on each day': 'Número de emociones presentadas cada día',

    'Student check-ins overview': 'Resumen de registros de estudiantes',
    'Comfortable emotions': 'Emociones agradables',
    'Uncomfortable emotions': 'Emociones desagradables',
    'Not assigned': 'Sin asignar',

    'Emotional Trends': 'Tendencias de emociones',
    'Time frame': 'Período de tiempo',

    'Same number of check-ins this selected period compared to previous.': 'Mismo número de registros en este período seleccionado en comparación con el anterior.',
    'More check-ins this selected period compared to previous.': 'más registros en este período seleccionado en comparación con el anterior.',
    'Fewer check-ins this selected period compared to previous.': 'menos registros en este período seleccionado en comparación con el anterior.',
    'More comfortable emotions this selected period compared to previous': 'más emociones agradables en este período seleccionado en comparación con el anterior.',
    'Fewer comfortable emotions this selected period compared to previous.': 'menos emociones agradables en este período seleccionado en comparación con el anterior.',

    'Use this search to find a student for deeper and advanced analytics': 'Usa esta búsqueda para encontrar a un estudiante y acceder a análisis más profundos y avanzados.',
    'This section displays the most common reasons behind the comfortable and uncomfortable emotions submitted by the student during the selected period':
        'Esta sección muestra las razones más comunes detrás de las emociones agradables y desagradables registradas por el estudiante durante el período seleccionado.',
    "This emotion shows student's last submitted mood check": 'Esta emoción muestra el último estado de ánimo registrado por el estudiante.',
    'This section displays alerts created for the student based on logged emotions or activities. You can view details, reasons, and the assigned status of each alert, and take or assign actions as needed.':
        'Esta sección muestra las alertas creadas para el estudiante con base en las emociones o actividades registradas. Puedes ver los detalles, las razones y el estado asignado de cada alerta, así como tomar o asignar acciones según sea necsari',
    'This section displays all assigned actions based on the student’s activities. You can view the status of each assignment to see if any action has been taken.':
        'Esta sección muestra todas las acciones asignadas con base en las actividades del estudiante. Puedes ver el estado de cada asignación para verificar si se ha tomado alguna acción.',
    'This section provides an overview of the student’s check-ins for the selected period. It shows the total number of check-ins, the percentage breakdown of comfortable and uncomfortable emotions, and highlights changes compared to the previous period.':
        'Esta sección proporciona un resumen de los registros del estudiante para el período seleccionado. Muestra el número total de registros, el desglose porcentual de emociones agradables y desagradables y resalta los cambios en comparación con el período anterior.',
    'This section shows trends in the student’s emotional check-ins over time. It highlights the percentage of comfortable and uncomfortable emotions, along with the time frame and number of check-ins. Key insights, such as the highest levels of comfortable and uncomfortable emotions, are displayed for better understanding.':
        'Esta sección muestra las tendencias en los registros emocionales del estudiante a lo largo del tiempo. Resalta el porcentaje de emociones agradables y desagradables, junto con el período de tiempo y el número de registros. Se presentan información clave, como los niveles más altos de emociones agradables y desagradables, para una mejor comprensión.',
    'This section displays the activities created for the student during the selected period. You can remind the student to complete activities or view detailed information about each activity.':
        'Esta sección muestra las actividades creadas para el estudiante durante el período seleccionado. Puedes recordarle al estudiante que complete las actividades o ver información detallada sobre cada una.',
    'This section provides an overview of the student’s logged emotions for the current school year. It highlights the total number of emotions recorded, along with the breakdown of comfortable and uncomfortable emotions as percentages.':
        'Esta sección proporciona un resumen de los registros del estudiante para el período seleccionado. Muestra el número total de registros, el desglose porcentual de emociones agradables y desagradables y resalta los cambios en comparación con el período anterior.',
    'This section compares the student’s wellbeing data to the class and year averages for the selected period. It highlights differences in percentages, showing how the student’s performance aligns with or deviates from their peers':
        'Esta sección proporciona un resumen de los registros del estudiante para el período seleccionado. Muestra el número total de registros, el desglose porcentual de emociones agradables y desagradables y resalta los cambios en comparación con el período anterior.',

    StudentWellbeingThisYear: 'Bienestar del alumno este año',
    TotalEmotions: 'Total de emociones',

    wellbeing_equal_average_year: '{{name}} tiene el mismo porcentaje de bienestar que el promedio anual.',
    wellbeing_equal_average_class: '{{name}} tiene el mismo porcentaje de bienestar que el promedio de la clase.',

    highestComfortableLabelMonth: 'El mes de {{date}} tuvo el nivel más alto de emociones cómodas.',
    highestComfortableLabelWeek: 'La semana del {{date}} tuvo el nivel más alto de emociones cómodas.',
    highestComfortableLabelDay: '{{date}} tuvo el nivel más alto de emociones cómodas.',

    highestUncomfortableLabelMonth: 'El mes de {{date}} tuvo el nivel más alto de emociones incómodas.',
    highestUncomfortableLabelWeek: 'La semana del {{date}} tuvo el nivel más alto de emociones incómodas.',
    highestUncomfortableLabelDay: '{{date}} tuvo el nivel más alto de emociones incómodas.',

    comparison_to_average_year: 'Comparación con el promedio anual',
    comparison_to_average_class: 'Comparación con el promedio de la clase',
    wellbeing_above_average_year: '{{name}} está un {{percentage}}% por encima del promedio anual de bienestar, ¡buen trabajo!',
    wellbeing_above_average_class: '{{name}} está un {{percentage}}% por encima del promedio de la clase en bienestar, ¡buen trabajo!',
    wellbeing_bellow_average_year: '{{name}} está un {{percentage}}% por debajo del promedio anual de bienestar.',
    wellbeing_bellow_average_class: '{{name}} está un {{percentage}}% por debajo del promedio de la clase en bienestar.',
    'Emotional Wellbeing Factors': 'Factores de Bienestar Emocional',
    'Student Wellbeing Comparison': 'Comparación de bienestar del alumno',

    Students: 'Alumnos',
    Student: 'Estudiante',
    Jan: 'Ene',
    Feb: 'Feb',
    Mar: 'Mar',
    Apr: 'Abr',
    May: 'May',
    Jun: 'Jun',
    Jul: 'Jul',
    Aug: 'Ago',
    Sep: 'Sep',
    Oct: 'Oct',
    Nov: 'Nov',
    Dec: 'Dic',

    Dashboard: 'Panel de control',
    'Current Emotion': 'Emoción actual',
    'All alerts': 'Todas las alertas',
    'Keyword settings': 'Ajustes de palabras clave',
    'Keyword alerts': 'Alertas de palabras clave',
    'Keyword Alert': 'Alertas de palabras clave',
    'Each of our ready-to-go surveys is designed to help you understand your students better':
        'Cada una de nuestras encuestas listas para usar está diseñada para ayudarte a comprender mejor a tus estudiantes',
    'Choose from our range of ready-to-go programs designed to support your students and save you time':
        'Elige de entre nuestros programas listos para aplicar diseñados para ayudar a tus estudiantes  y para ahorrarte tiempo',
    'Pick a journal that will keep your students engaged': 'Elige un diario que mantenga a tus estudiantes interesados',
    Programs: 'Programas',
    Surveys: 'Encuestas',
    Journals: 'Diarios',
    'General Wellbeing': 'Bienestar general',
    'Personal Wellbeing': 'Bienestar personal',
    'Stress Management': 'Manejo del estrés',
    'Self-management': 'Autogestión',
    SEL: 'SEL',
    'This is a great place to start if you’re looking for some general wellbeing content before diving into some of the more specific topics.':
        'Este es un excelente lugar para comenzar si buscas contenido general sobre bienestar antes de sumergirte en algunos de los temas más específicos.',
    'Here you’ll find more personal wellbeing content designed to help you and your students learn more about specific challenges and ways to overcome them.':
        'Aquí encontrarás más contenido sobre bienestar personal diseñado para ayudarte a ti y a tus estudiantes a aprender más sobre desafíos específicos y formas de superarlos.',
    'If it’s a school-related topic such as getting organised, excelling in exams, or being productive, it’s right here for you!':
        'Aquí encontrarás más contenido sobre bienestar personal diseñado para ayudarte a ti y a tus estudiantes a aprender más sobre desafíos específicos y formas de superarlos.',
    'Find out more about your students’ & colleagues’ experiences of stress with a survey and support them with a range of stress management tools.':
        'Descubre más sobre las experiencias de estrés de tus estudiantes y colegas con una encuesta y apóyalos con una variedad de herramientas de manejo del estrés.',
    'Our range of social and emotional learning (SEL) content is all designed to help you & your students enhance self-awareness and develop greater self-management skills.':
        'Nuestro rango de contenido de aprendizaje social y emocional (SEL) esta diseñado para ayudarte a ti y a tus estudiantes a mejorar la autoconsciencia y desarrollar mejores habilidades de autogestión.',

    'Assigned to me': 'Asignado a mi',
    'Assigned to others': 'Asignado a otros',
    Completed: 'Completado',
    'See alert': 'Ver alerta',
    'Take action': 'Tomar acción',
    'Review content': 'Revisar contenido',
    Decline: 'Rechazar',
    Accept: 'Aceptar',
    'Content has been approved': 'El contenido ha sido aprobado',
    'Content has been declined': 'El contenido ha sido rechazado',
    "You don't have any content to review": 'No tienes ningún contenido para revisar',
    'Multiple Uncomfortable Emotions': 'Múltiples emociones desagradables',

    'Class Average': 'Promedio de clase',
    'Same as class average': 'Igual que el promedio de la clase',
    'Less than class average': 'Más bajo que el promedio de la clase',
    'More than class average': 'Más alto que el promedio de la clase',

    'Student activities vs class average': 'Actividades del estudiante vs. promedio de la clase',
    Completion: 'Finalización',
    'Class average': 'Promedio de la clase',
    'completed activities': 'Actividades completadas',
    Comparison: 'Comparación',
    'Emotions logged': 'Emociones registradas',
    'Class Average of Comfortable Emotions': 'Promedio de emociones agradables de la clase',

    'Reasons for Emotions': 'Motivos de las emociones',
    'Show More Reasons': 'Mostrar más motivos',
    'Show Less Reasons': 'Mostrar menos motivos',
    'Assigned by': 'Asignado por',
    Message: 'Mensaje',
    'Show More': 'Mostrar más',
    'Show Less': 'Mostrar menos',

    "Check out John's responses to app activities": ' Revisa las respuestas de {{name}} a las actividades de la aplicación',
    'Activities John has participated in': 'Actividades en las que {{name}} ha participado',

    'Search for activities': 'Buscar actividades',
    'Average participation rate': 'Tasa promedio de participación',
    'Check activity responses here': 'Consulta las respuestas a la actividad aquí',
    Remind: 'Recordar',
    Details: 'Detalles',
    'View Less': 'Ver menos',
    'View All': 'Ver todo',
    'Export PDF': 'Exportar PDF',
    Assigned: 'Asignado',
    assigned: 'asignado',
    'took an action': 'tomó una acción',
    'with the following message': 'con el siguiente mensaje:',
    answer: 'Respuesta',
    'This content is anonymous, so you won’t be able to see any responses': 'Este contenido es anónimo, por lo que no podrás ver ninguna respuesta.',

    'Show less': 'Mostrar menos',
    'Show more': 'Mostrar más',
    Complete: 'Completo',
    Status: 'Estado',
    'View less': 'Ver menos',
    'View all': 'Ver todo',
    Reminded: 'Recordado',
    'Show less reasons': 'Mostrar menos motivos',
    'Show more reasons': 'Mostrar más motivos',

    'Search to see student analytics': 'Buscar para ver análisis del estudiante',
    Logged: 'Registrado',
    'Occurs every Monday until 01/01/2025': 'Ocurre todos los lunes hasta el 01/01/2025',
    'Search for student or class analytics': 'Buscar análisis del estudiante o de la clase',
    'Search for classes': 'Buscar clases',
    'Search for': 'Buscar por',
    'Class wellbeing for this school year': 'Bienestar de la clase para este año escolar',

    'Shows the total emotions logged by the class so far this year, with a simple breakdown into comfortable and uncomfortable emotions':
        'Muestra el total de emociones registradas por la clase hasta ahora este año, con un desglose simple entre emociones agradables y desagradables.',
    'Class Emotional Wellbeing by Student': 'Bienestar emocional de la clase por estudiante',
    'This section displays key factors impacting each student’s emotional wellbeing, with a breakdown of comfortable and uncomfortable emotions.':
        'Esta sección muestra los factores clave que impactan el bienestar emocional de cada estudiante, con un desglose de emociones agradables y desagradables',
    'Show less students': 'Mostrar menos estudiantes',
    'See all students': 'Ver todos los estudiantes',
    'Class check-ins overview': 'Resumen de los registros emocionales de la clase',
    'Shows the class’s emotional check-ins for the selected period, with a breakdown of comfortable and uncomfortable emotions.':
        'Muestra los registros emocionales de la clase para el período seleccionado, con un desglose de emociones agradables y desagradables',
    'Class Emotional Trends': 'Tendencias emocionales de la clase',
    'Class Engagement in Activities': 'Participación de la clase en actividades',
    'Check class activity responses here': 'Consulta las respuestas de la actividad de la clase aquí',
    'Load More': 'Cargar más',
    'Class participation': 'Participación de la clase',
    'Class Emotional Wellbeing Factors': 'Factores del bienestar emocional de la clase',
    'Class Wellbeing Comparison': 'Comparación del bienestar de la clase',
    'School average': 'Promedio de la escuela',
    'This section shows alerts for students who have logged 3 consecutive uncomfortable emotions. You can use these alerts to monitor your students’ emotional wellbeing and take necessary actions.':
        'Esta sección muestra alertas para los estudiantes que han registrado 3 emociones desagradables consecutivas. Puedes usar estas alertas para monitorear el bienestar emocional de tus estudiantes y tomar las acciones necesarias',
    'This section displays the average participation of the class in all activities over the selected period. Use this to monitor engagement and identify areas where students may need more support or encouragement':
        'Esta sección muestra la participación promedio de la clase en todas las actividades durante el período seleccionado. Utiliza esto para monitorear la participación e identificar áreas donde los estudiantes puedan necesitar más apoyo o estímulo',
    'This section displays the factors contributing to the class’s comfortable and uncomfortable emotions. View the breakdown of each emotion type, along with the most common contributing factors for the selected period.':
        'Esta sección muestra los factores que contribuyen a las emociones agradables y desagradables de la clase. Visualiza el desglose de cada tipo de emoción, junto con los factores más comunes que contribuyen durante el período seleccionado.',

    'From creating confidence to goal setting, you’ll find a great range of skill-based surveys, programs, and journals here.':
        'Desde crear confianza hasta establecer metas, aquí encontrarás una gran variedad de encuestas basadas en habilidades, programas y diarios.',
    'Class analytics': 'Analítica de clase',
    'Student analytics': 'Analítica del estudiante',
    'We found student(s)': 'Encontramos {{total}} estudiante(s)',
    'We found class(es)': 'Encontramos {{total}} clase(s)',

    'Number of class engagements': 'Número de partidipaciones en clase',
    'Average class participation rate': 'Tasa promedio de participación de la clase',
    'Number of surveys': 'Número de encuestas',
    'Avg. participation rate': 'Tasa promedio de participación',
    'Number of polls': 'Número de sondeos',
    'Number of questions': 'Número de preguntas',
    'Your class': 'Tu clase',
    'We found 5 result(s) based on your search': 'Encontramos {{total}} resultado(s) basados en tu búsqueda',
    'Classroom analytics': 'Analítica del aula',
    Loading: 'Cargando',
    'No data to show based on your search': 'No hay datos para mostrar según tu búsqueda',
    'Skip guide': 'Omitir guía',
    'Close guide': 'Cerrar guía',
    'Next page': 'Siguiente página',
    "Don't show again": 'No mostrar de nuevo',

    student_analytics_welcome: 'WBienvenido a la analítica de estudiantes. Este recorrido te guiará a través de una introducción a cada segmento.',
    student_analytics_student_info: 'Esta sección muestra la información del estudiante.',
    student_analytics_content: 'Aquí puedes ver la analítica del estudiante.',
    student_analytics_personal_info: 'La información personal del estudiante se muestra aquí.',
    student_analytics_emotional_info: 'El estado emocional del estudiante durante el último año se muestra aquí.',
    student_action_buttons: 'Estos botones son acciones que puedes tomar para ayudar al estudiante.',
    student_analytics_filter: 'Este es el filtro que puedes usar para seleccionar un período de tiempo para la analítica.',
    student_analytics_checkins:
        'La información de los registros del estudiante se muestra aquí. Puedes revisar el estado emocional del estudiante basado en emociones agradables y desagradables.',
    student_analytics_wellbeing_comparison: 'La información mostrada aquí es una comparación entre el bienestar del estudiante y los promedios de la clase o del año.',
    student_analytics_emotional_trends:
        'Las tendencias emocionales del estudiante se muestran aquí. El gráfico depende del período de tiempo que selecciones en el filtro en la parte superior de la página.',
    student_analytics_emotional_wellbeing_factors:
        'Aquí se muestran los factores que afectan el bienestar emocional del estudiante, divididos en dos secciones. También puedes hacer clic en el botón "Mostrar más razones" para mostrar todas las emociones agradables y desagradables que el estudiante está experimentando.',
    student_analytics_alerts:
        'Las alertas para emociones desagradables se muestran aquí. Al hacer clic en el botón a la derecha puedes abrir información adicional sobre una alerta específica.',
    student_analytics_alerts_single_item:
        'Cada alerta muestra la emoción y las razones para esa emoción con una fecha. Al hacer clic en los botones en la parte inferior de la alerta, puedes tomar acción o asignar a alguien más para que la tome.',
    student_analytics_assigned_actions:
        'Todas las acciones asignadas al estudiante se muestran aquí. Cada acción tiene un estado, quién la asignó y a quién, la fecha en que se asignó y un mensaje del asignador al destinatario.',
    student_analytics_participation: 'Todas las actividades en las que el estudiante participó se muestran aquí.',
    student_analytics_participation_actions: 'Al hacer clic en estos botones, podemos recordar sobre las actividades o mostrar detalles de las actividades.',
    class_analytics_welcome: 'Bienvenido a la analítica de clase. Este recorrido te guiará a través de una introducción a cada segmento.',
    class_analytics_class_info: 'Esta sección muestra la información de la clase.',
    class_analytics_content: 'Aquí puedes ver la analítica de la clase.',
    class_analytics_info: 'La información de la clase se muestra aquí.',
    class_analytics_emotional_info: 'El estado emocional de la clase durante el último año se muestra aquí.',
    class_analytics_filter: 'Este es el filtro que puedes usar para seleccionar un período de tiempo para la analítica.',
    class_analytics_checkins:
        'La información de los registros de la clase se muestra aquí. Puedes revisar el estado emocional de la clase basado en emociones agradables y desagradables.',
    class_analytics_wellbeing_comparison: 'La información mostrada aquí compara el bienestar de la clase con los promedios anuales y de la escuela',
    class_analytics_emotional_trends:
        'Las tendencias emocionales de la clase se muestran aquí. El gráfico depende del período de tiempo que selecciones en el filtro en la parte superior de la página.',
    class_analytics_emotional_wellbeing_factors:
        'Aquí se muestran los factores que afectan el bienestar emocional de la clase, divididos en dos secciones. También puedes hacer clic en el botón "Mostrar más razones" para ver todas las emociones agradables y desagradables que la clase está experimentando.',
    class_emotional_wellbeing_by_student: 'Esta sección muestra las emociones agradables y desagradables de cada estudiante en la clase.',
    class_emotional_wellbeing_by_student_single: 'Al hacer clic en cada ítem individual se abre una vista de los motivos de las emociones del estudiante.',
    class_analytics_alerts:
        'Las alertas para emociones desagradables se muestran aquí. Al hacer clic en el botón a la derecha, puedes abrir información adicional sobre una alerta específica.',
    class_analytics_alerts_single_item:
        'Cada alerta muestra la emoción y los motivos para esa emoción con una fecha. Al hacer clic en los botones en la parte inferior de la alerta, puedes tomar acción o asignar a alguien más para que lo haga.',
    class_analytics_assigned_actions:
        'Todas las acciones asignadas a cada estudiante en la clase se muestran aquí. Cada acción tiene un estado, quién la asignó y a quién, la fecha en que se asignó y un mensaje del asignador al destinatario.',
    class_analytics_participation: 'Todas las actividades en las que los estudiantes de la clase participaron se muestran aquí.',
    class_analytics_participation_actions: 'Al hacer clic en estos botones, podemos recordar sobre las actividades o mostrar detalles de las actividades.',
    comparison_to_average_school: 'Comparación con el promedio de la escuela',
    wellbeing_equal_average_school: '{{name}} tiene el mismo porcentaje de bienestar que el promedio de la escuela',
    wellbeing_above_average_school: '{{name}} está un {{percentage}}% por encima del promedio de bienestar de la escuela, gran trabajo!',
    wellbeing_bellow_average_school: '{{name}} está un {{percentage}}% por debajo del promedio de bienestar de la escuela',

    '2 years ago': 'Hace {{number}} {{period}}',
    '2 months ago': 'Hace {{number}} {{period}}',
    '2 days ago': 'Hace {{number}} {{period}}',
    'Year average': 'Promedio del año',
    "This data compares your class's wellbeing to the average wellbeing of the year group and the school overall":
        'Estos datos comparan el bienestar de tu clase con el bienestar promedio del grupo de año y de la escuela en general',
    "Here you'll see the class's emotional wellbeing over the selected period, showing the breakdown of comfortable and uncomfortable emotions":
        'Aquí verás el bienestar emocional de la clase durante el período seleccionado, mostrando el desglose de emociones agradables y desagradables',
    "Here you'll find actions that have been assigned to students, including their current status (Assigned or Completed). Track who assigned the action, when it was assigned, and any comments or updates related to the action.":
        'Aquí encontrarás las acciones que han sido asignadas a los estudiantes, incluyendo su estado actual (Asignado o Completado). Haz un seguimiento de quién asignó la acción, cuándo se asignó y cualquier comentario o actualización relacionada con la acción',
    'has logged multiple uncomfortable emotions': 'Ha registrado múltiples emociones desagradables',
    'Browse All Classes': 'Navegar por todas las clases',
    'Class not selected': 'Clase no seleccionada',
    'Click to move all to top': 'Haz clic para mover todo al inicio',
    'Click “proceed” to get back to the class screen': 'Haz clic en "proceder" para volver a la pantalla de la clase',
    Confirm: 'Confirmar',
    'Does this best describe how you’re feeling right now,': '¿Esto describe mejor cómo te sientes en este momento,',
    'Emotion successfully selected': 'Emoción seleccionada con éxito',
    'Emotions distribution': 'Distribusión de emociones',
    'Get Back': 'Regresar',
    'Get Deeper Insights': 'Obtener información más detallada',
    'It is needed to prevent students from entering teacher’s environment': 'Este paso es necesario para evitar que los estudiantes accedan al entorno del maestro.',
    'Main Dashboard': 'Tablero principal',
    'My Classes': 'Mis clases',
    'Open analytics': 'Abrir analítica',
    Selected: 'Seleccionado',
    Proceed: 'Proceder',
    Profile: 'Perfil',
    'Repeat security key': 'Repetir clave de seguridad',
    'Repeat security key here': 'Repetir clave de seguridad aquí',
    'Search Class': 'Buscar clase',
    "Secret keys don't match": 'Las claves secretas no coinciden',
    'Setup your security key first': 'Configura tu clave de seguridad primero',
    'Stay up to date with student support': 'Mantente al día con el apoyo a los estudiantes',

    'Enter your security key to access settings': 'Ingresa tu clave de seguridad para acceder a la configuración',
    'Enter your security key to reset your answers': 'Ingresa tu clave de seguridad para restablecer tus respuestas',
    'Enter your security key to switch from the child view to the teacher view': 'Ingresa tu clave de seguridad para cambiar de la vista de estudiante a la vista de maestro.',
    'User Management': 'Gestión de usuarios',
    'Which image best describes how you’re feeling right now?': '¿Cuál imagen describe mejor cómo te sientes en este momento?',
    'Wrong secret key': 'Clave secreta incorrecta',
    afraid: 'Temeroso',
    'Security Key': 'Clave de seguridad',
    'Security key is needed to switch from child environment to teacher environment': 'Ingresa tu clave de seguridad para cambiar de la vista de niño a la vista de maestro',
    'Congrats!': '¡Felicidades!',
    'Security key has been set': 'La clave de seguridad ha sido configurada',
    Logout: 'Carrar sesión',
    Settings: 'Configuarción',
    'Change Avatars': 'Cambiar avatares',
    'Go to Class Analytics': 'Ir a analítica de clase',
    'Browse emotion distribution': 'Ver distribución de emociones',
    Congratulations: 'Felicidades',
    'Congratulations!': '¡Felicidades!!',
    'Everyone replied': 'Todos respondieron',
    'No one replied yet': 'Nadie ha respondido aún',
    'Next Tutorial': 'Siguiente tutorial',
    'Previous Tutorial': 'Tutorial anterior',

    'Exciting New Analytics': 'Nuevas Analíticas Emocionantes',
    'New Student, Class and Grade Analytics': 'Nuevas Analíticas por Estudiante, Clase y Grado',
    'Better insights for you and your school': 'Mejores conocimientos para ti y tu escuela',
    'Now you can see how a student or class is doing compared to their own data, other classes, or the entire grade.':
        'Ahora puedes ver cómo le va a un estudiante o clase en comparación con sus propios datos, otras clases o todo el grado',
    'Student Wellbeing Details': 'Detalles del Bienestar del Estudiante',
    'Check-Ins Overview': 'Resumen de registros',
    'Less data, more information': 'Menos datos, más información',
    'See at a glance how often the student has checked in and the emotions they’ve logged.':
        'Ve de un vistazo con qué frecuencia el estudiante ha realizado su registro y las emociones que ha registrado',
    'Compare Students to Class': 'Comparar Estudiantes con la Clase',
    'Get Deeper Insights': 'Obtener Información Más Detallada',
    'Get everything you need to make informed decisions.': 'Obtén todo lo que necesitas para tomar decisiones informadas',

    'Quickly see how a student’s wellbeing compares to their class or year group.':
        'Ve rápidamente cómo se compara el bienestar de un estudiante con el de su clase o grupo de año.',
    'Valuable Information': 'Información Valiosa',
    'Powerful Wellbeing Analytics': 'Poderosa analítica de bienestar',
    'Get everything you need to make more informed decisions.': 'Obtén todo lo que necesitas para tomar decisiones más informadas',
    'Dive deep into wellbeing data to spot trends and draw meaningful conclusions.':
        'Profundiza en los datos de bienestar para detectar tendencias y sacar conclusiones significativas',
    'Actionable Classroom Data': 'Datos Accionables del Aula',
    'Explore Trends Across Classes and Grades': 'Explora Tendencias Entre Clases y Grados',
    'Gain valuable insights into how your class is doing.': 'Obtén información valiosa sobre cómo le va a tu clase',
    'Uncover key wellbeing trends across classes and year groups.': 'Descubre las principales tendencias de bienestar entre clases y grupos de año',
    'Classroom Engagement': 'Participación de Aula',
    'Track student engagement in Upstrive activities': 'Haz seguimiento de la participación de los estudiantes en las actividades de Upstrive',
    'How are they doing?': '¿Cómo les está yendo?',
    'Get the insights you need to understand student engagement in Upstrive activities.':
        'Obtén la información que necesitas para entender el compromiso de los estudiantes en las actividades de Upstrive.',
    'Accessing Analytics': 'Acceso a Analíticas',
    'Search Smarter': 'Búsqueda Inteligente',
    'Enter a student or class name to access the new Analytics. You can also view student-specific insights by clicking on a student in the Classroom section.':
        'Ingresa el nombre de un estudiante o clase para acceder a las nuevas analíticas. También puedes ver información específica de un estudiante haciendo clic en su nombre en la sección del aula.',
    'Open Student View': 'Abrir Vista del Estudiante',
    '% of students using Upstrive (per week, any function)': '% de estudiantes usando Upstrive (por semana, en cualquier función)',
    'Open Upstrive Education': 'Abrir Upstrive Education',
    'Open Upstrive Early': 'Abrir Upstrive Early',
    'AI-Powered Wellbeing Alerts – Important Notice': 'Alertas de Bienestar Impulsadas por IA – Aviso Importante',
    'Number of emotions to trigger an alert': 'Número de emociones necesarias para activar una alerta',
    'Assigned to other': 'Asignado a otra persona',
    'Email notifications': 'Notificaciones por correo electrónico',
    'Emotions to track': 'Emociones a monitorear',
    'Help us improve': 'Ayúdanos a mejorar',

    'Here you can manage who will receive the email notifications for different types of alerts':
        'Aquí puedes administrar quién recibirá las notificaciones por correo electrónico para los diferentes tipos de alertas',
    'Here you can manage who will receive the in-app notifications for different types of alerts':
        'Aquí puedes administrar quién recibirá las notificaciones dentro de la app para los diferentes tipos de alertas',
    'Here you can manage who will receive the push notifications for different types of alerts':
        'Aquí puedes administrar quién recibirá las notificaciones push para los diferentes tipos de alertas',
    'How would you rate the accuracy of flagging this comment as a risk? From low (1) to high (5)':
        '¿Cómo calificarías la precisión al marcar este comentario como un riesgo? De baja (1) a alta (5)',
    'I Understand': 'Entiendo',
    'In-App': 'En la app',
    'In-app notifications': 'Notificaciones dentro de la app',
    'Keyword alerts receipient(s) email': 'Correo(s) de destinatario(s) de alertas por palabra clave',
    'Keyword alerts receipient(s) notifications': 'Notificaciones de destinatario(s) de alertas por palabra clave',
    'Mark as false alert': 'Marcar como falsa alerta',
    'No matching options': 'No hay opciones que coincidan',
    'Custom email': 'Correo electrónico personalizado',
    'Thank you for helping us!': '¡Gracias por ayudarnos!',
    Triggers: 'Detonantes',
    'Uncomfortable emotions receipient(s) email': 'Correo(s) de destinatario(s) de emociones desagradables',
    'Uncomfortable emotions receipient(s) notifications': 'Notificaciones de destinatario(s) de emociones desagradables',
    'Uncomfortable emotions triggers': 'Detonadores de emociones desagradables',
    'Your feedback helps us improve our system for detecting keywords!': '¡Tu retroalimentación nos ayuda a mejorar nuestro sistema para detectar palabras clave!',
    'in a row': 'Consecutivas',
    notificationSettings: 'Configuaración de notificaciones',
    'Notifications settings': 'Configuaración de notificaciones',
    push: 'Push',
    pushNotifications: 'Notificaciones push',
    'included in their response': 'incluido en su respuesta',
    Numbness: 'Desgano',
    Worry: 'Preocupación',
    Stress: 'Estrés',
    Sadness: 'Tristeza',
    Anger: 'Ira',
    Lethargy: 'Cansancio',
    Grumpiness: 'Molestia',
    'Feeling emotionally disconnected or unable to process emotions': 'Sentimiento de desconexión emocional o incapacidad para procesar emociones',
    'Feeling uneasy about something uncertain or future-related': 'Sentirse inquieto por algo incierto o relacionado con el futuro',
    'Feeling overwhelmed or pressured due to challenges, responsibilities, or expectations': 'Sentirse abrumado o presionado debido a desafíos, responsabilidades o expectativas',
    'A deep feeling of unhappiness or disappointment': 'Un sentimiento profundo de infelicidad o decepción',
    'A strong feeling of frustration or annoyance, often in response to something unfair or upsetting':
        'Un sentimiento fuerte de frustración o molestia, a menudo en respuesta a algo injusto o perturbador',
    'Feeling tired, drained, sluggish, or low in energy': 'Sentirse cansado, agotado, lento o con poca energía',
    'Feeling irritated or easily annoyed, sometimes without a clear reason': 'Sentirse irritado o fácilmente molesto, a veces sin una razón clara',
    'If needed, you can flag this comment': 'Si es necesario, puedes marcar este comentario',
    'Mark comment as risk': 'Marcar comentario como riesgo',
    'This comment has not been marked as a risk, you can change that by clicking the button':
        'Este comentario no ha sido marcado como un riesgo, puedes cambiar eso haciendo clic en el botón',
    'This entry was flagged by': 'Esta entrada fue marcada por',
    'This entry was flagged by AI for': 'Esta entrada fue marcada por IA por',
    violence: 'Violencia',
    'self harm': 'Autolesión',
    'sexual references': 'Referencia sexual',

    sexual: 'sexual',
    hate: 'Odio',
    harassment: 'Acoso',
    'sexual/minors': 'sexual/minors', // to be translated
    'self-harm/intent': 'self-harm/intent', // to be translated
    'Start Journalling!': '¡Comienza a llevar un diario!',

    'Select who gets notified when a student selects uncomfortable emotions over multiple consecutive check-ins':
        'Selecciona quién será notificado cuando un estudiante seleccione emociones desagradables durante múltiples registros consecutivos.',
    'Choose who should receive emails when a student uses flagged keywords in their check-in comments':
        'Elige quién debe recibir correos electrónicos cuando un estudiante utilice palabras clave marcadas en sus comentarios de registro.',
    'Manage who receives email notifications for different types of alerts triggered by student check-ins':
        'Gestiona quién recibirá notificaciones por correo electrónico para diferentes tipos de alertas activadas por los registros de estado emocional de los estudiantes.',
    'Select who should receive push notifications for flagged keywords and for multiple consecutive uncomfortable emotions logged':
        'Selecciona quién debe recibir notificaciones push para palabras clave marcadas y para múltiples registros consecutivos de emociones desagradables.',
    'Select who should receive push notifications when a student’s check-in includes flagged keywords':
        'Selecciona quién debe recibir notificaciones push cuando el registro de un estudiante incluya palabras clave marcadas.',
    'Select who should receive push notifications when students select uncomfortable emotions over multiple consecutive check-ins':
        'Selecciona quién debe recibir notificaciones push cuando los estudiantes seleccionen emociones desagradables durante múltiples registros consecutivos.',
    'Manage how many times uncomfortable emotions need to appear before triggering an alert, and choose which emotions to track':
        'Gestiona cuántas veces deben aparecer emociones desagradables antes de activar una alerta y elige qué emociones seguir.',
    'Select how many days in a row a student must log uncomfortable emotions before an alert is sent':
        'Selecciona cuántos días consecutivos debe registrar un estudiante emociones desagradables antes de que se envíe una alerta.',
    'Choose which specific uncomfortable emotions will be monitored for alerts': 'Elige qué emociones incómodas específicas serán monitoreadas para alertas.',

    content: 'Contenido',

    //to be translated very new staff
    'sexual/minors': 'sexual/minors', // to be translated
    'self-harm/intent': 'self-harm/intent', // to be translated
    'Choose how many times a student must select an uncomfortable emotion before an alert is triggered, and select which emotions you want to track':
        'Choose how many times a student must select an uncomfortable emotion before an alert is triggered, and select which emotions you want to track.',
    visitOurWebsiteForMoreDetails: 'Visit our <white>website</white> for more details.',
    'Alerts for selected student groups': 'Alerts for selected student groups',
    'All Activities': 'All Activities',
    'All classes': 'All classes',
    'By number of alerts': 'By number of alerts',
    'By number of assigned': 'By number of assigned',
    'By number of unassigned': 'By number of unassigned',
    'Check-ins overview for selected student groups': 'Check-ins overview for selected student groups',
    Comfortable: 'Comfortable',
    'Counsellor analytics': 'Counsellor analytics',
    'Counselor Emotional Wellbeing Factors': 'Counselor Emotional Wellbeing Factors',
    'Demo text': 'Demo text',
    'Emotional trends for selected student groups': 'Emotional trends for selected student groups',
    'Engagement in activities for selected student groups': 'Engagement in activities for selected student groups',
    'Option 1': 'Option 1',
    'Option 2': 'Option 2',
    'School average - emotions logged': 'School average - emotions logged',
    'See Class Analytics': 'See Class Analytics',
    'See all years': 'See all years',
    'See analytics': 'See analytics',
    'See Analytics': 'See Analytics',
    'Select all classes': 'Select all classes',
    'Show less Years': 'Show less Years',
    Uncomfortable: 'Uncomfortable',
    'Wellbeing comparison for selected student groups': 'Wellbeing comparison for selected student groups',
    'Year 1 average': 'Year {{name}} average',
    alerts: 'alerts',
    has: 'has',
    unassigned: 'unassigned',
    'See less years': 'See less years',
    'Whole school': 'Whole school',
    alert: 'alert',

    'Compare the wellbeing of different groups against the school average to spot trends and outliers.':
        'Compare the wellbeing of different groups against the school average to spot trends and outliers.',
    Counsellor: 'Counsellor',
    'This data shows the ratio of logged emotions from the start of the school year until today':
        'This data shows the ratio of logged emotions from the start of the school year until today',
    'More comfortable emotions logged during this period compared to the previous one.': 'More comfortable emotions logged during this period compared to the previous one.',
    'Overall balance of emotions logged since the start of the school year.': 'Overall balance of emotions logged since the start of the school year.',
    'Same number of check-ins recorded during this period compared to the previous one': 'Same number of check-ins recorded during this period compared to the previous one',
    'Same number of comfortable emotions logged during this period compared to the previous one.':
        'Same number of comfortable emotions logged during this period compared to the previous one.',
    'School-wide emotional breakdown based on number check-ins': 'School-wide emotional breakdown based on {{number}} check-ins',
    'Search All Analytics': 'Search All Analytics',
    'See how feeling factors are influencing students’ emotions.': 'See how feeling factors are influencing students’ emotions.',
    'Select which classes to include in the school-wide analytics view.': 'Select which classes to include in the school-wide analytics view.',
    'Track how selected groups are engaging with activities, programs, and content.': 'Track how selected groups are engaging with activities, programs, and content.',
    'Use this search to explore student, class, or counsellor analytics and access deeper insights.':
        'Use this search to explore student, class, or counsellor analytics and access deeper insights.',
    'View all keyword and emotion alerts for selected year groups.': 'View all keyword and emotion alerts for selected year groups.',
    'View check-in and emotion trends over time to spot changes in student engagement': 'View check-in and emotion trends over time to spot changes in student engagement',
    'View trends in comfortable and uncomfortable emotions to spot key patterns and peaks.':
        'View trends in comfortable and uncomfortable emotions to spot key patterns and peaks.',
    'fewer check-ins recorded during this period compared to the previous one': 'fewer check-ins recorded during this period compared to the previous one',
    'fewer comfortable emotions logged during this period compared to the previous one.': 'fewer comfortable emotions logged during this period compared to the previous one.',
    'more check-ins recorded during this period compared to the previous one': 'more check-ins recorded during this period compared to the previous one',

    'Last email with password was sent': 'Last email with password was sent',
    'Here you can manage who will receive the in-app notifications for different types of alerts':
        'Here you can manage who will receive the in-app notifications for different types of alerts',

    // Translation for the ES language
    "I think I'm feeling this way because": 'Creo que me siento así porque...',
    'Nothing in Chat yet — new messages will appear here': 'Aún no hay nada en el chat — los nuevos mensajes aparecerán aquí.',
    'No responses yet — check back soon!': 'Aún no hay respuestas — ¡vuelve pronto!',
    'Program successfully shared': 'Programa compartido con éxito',
    '6 check-ins per student': '6 check-ins per student',
    'All schools': 'All schools',
    'Number of check-ins on weekly basis in selected timeframe': 'Number of check-ins on weekly basis in selected timeframe',
    'Number of students': 'Number of students',
    Organization: 'Organization',
    'Organization analytics': 'Organization analytics',
    'Organization average': 'Organization average',
    'Organization average number': 'Organization average number',
    'See all organizations': 'See all organizations',
    'See less organizations': 'See less organizations',
    'Select all schools': 'Select all schools',
    'Select which schools to include in the organization-wide analytics view.': 'Select which schools to include in the organization-wide analytics view.',
    'Student Check-In Activity': 'Student Check-In Activity',
    'The average number of check-ins per student for the selected timeframe on weekly basis.':
        'The average number of check-ins per student for the selected timeframe on weekly basis.',
    'Year {{year}} average': 'Year {{year}} average',
    school_average: 'school_average',
    backToLogin: 'Zurück zu Login',
    backToForgotPassword: 'Zurück zu Passwort vergessen',
    'Run journal': 'Run journal',

    'Preparing your data': 'Preparando tus datos',
    'Number of responses per day': 'Número de respuestas por día',
    'Number of responses': 'Número de respuestas',
    'Actions taken': 'Acciones realizadas',
    "Teachers' actions": 'Acciones de los maestros',
    'Times logged': 'Veces registradas',
    'Describe how you will respond': 'Describe cómo vas a responder',
    'Assign to': 'Asignar a',
    enterYourWorkEmailAndPassword: 'Ingresa tu correo electrónico laboral y contraseña',

    Actions: 'Acciones',
    'Additional Options': 'Opciones Adicionales',
    All: 'Todo',
    'Are you sure you want to delete this scheduled email?': '¿Está seguro de que desea eliminar este correo electrónico programado?',
    'Delete scheduled email': 'Eliminar correo electrónico programado',
    'Disable password prompt': 'Deshabilitar solicitud de contraseña',
    'Disable prompt for new password when login': 'Deshabilitar solicitud de nueva contraseña al iniciar sesión',
    'Email scheduled successfully': 'Correo electrónico programado con éxito',
    'Email will be send on': 'El correo electrónico se enviará el',
    'Error deleting scheduled email': 'Error al eliminar el correo electrónico programado',
    'Failed to delete scheduled email': 'No se pudo eliminar el correo electrónico programado',
    'Label (optional)': 'Etiqueta (opcional)',
    'Manage your email schedule': 'Gestionar tu programación de correo electrónico',
    New: 'Nuevo',
    'No Scheduled Emails': 'No hay correos electrónicos programados',
    'Save to masterlist': 'Guardar en la lista maestra',
    'Schedule Summary': 'Resumen de programación',
    'Scheduled Date': 'Fecha programada',
    'Scheduled email deleted successfully': 'Correo electrónico programado eliminado con éxito',
    'Select Students': 'Seleccionar estudiantes',
    'Select Teachers': 'Seleccionar profesores',
    'Send emails to users based on timezone': 'Enviar correos electrónicos a los usuarios según la zona horaria',
    Sent: 'Enviado',
    'Set date': 'Establecer fecha',
    'Set label(for internal use)': 'Establecer etiqueta (para uso interno)',
    'Set time': 'Establecer hora',
    'Target Group': 'Grupo objetivo',
    'View scheduled emails': 'Ver correos electrónicos programados',
    at: 'en',
    'Responding to': 'Respondiendo a',
    'Need a template?': '¿Necesitas una plantilla?',
    'Confirm Password': 'Confirmar contraseña',
    'Re-enter your new password': 'Vuelve a introducir tu nueva contraseña',
    'Select Recipients': 'Seleccionar destinatarios',
    'Select individual students or create a group to share this content with': 'Selecciona estudiantes individuales o crea un grupo para compartir este contenido',
    'Select specific year groups to share this content with': 'Selecciona grupos de curso específicos para compartir este contenido',
    'Select specific classes to share this content with': 'Selecciona clases específicas para compartir este contenido',
    'Select staff members to share this content with': 'Selecciona miembros del personal para compartir este contenido',

    'Do you want to pause the program?': '¿Quieres pausar el programa?',
    'Resume program': 'Reanudar programa',
    'Stop program': 'Detener programa',
    'Share your thoughts here': 'Comparte tus pensamientos aquí...',
    'This tool lets you manage your active programs': 'Esta herramienta te permite gestionar tus programas activos',
    stopProgram: 'Detener programa',
    'Refreshed videos': 'Videos actualizados',

    'Selecting role is required': 'La selección de un rol es obligatoria',
    'Content is not deleted': 'El contenido no se eliminó',
    Unspecified: 'No especificado',
    'Number of teachers who answered "How are you today?" on this date': 'Número de profesores que respondieron "¿Cómo te sientes hoy?" en esta fecha',
    uploadHelperText: 'Tamaño máximo de carga:\nImágenes: hasta 5 MB (máx. 1400 × 1400 px)\nVideos: hasta 50 MB',
    imageTooLarge: 'La imagen es demasiado grande (máx. 5 MB)',
    videoTooLarge: 'El video es demasiado grande (máx. 50 MB)',
    invalidImageFormat: 'Formato de imagen no válido (permitido: JPG, PNG, WEBP)',
    invalidVideoFormat: 'Formato de video no válido (permitido: MP4, WEBM)',
    listOfUsersWhoHaventLoggedInYet: 'Lista de usuarios que aún no han iniciado sesión',
    'Average number of responses daily': 'Número promedio de respuestas diarias',
    'Error generating QR code': 'Error al generar el código QR',
}
export default TRANSLATION_ES
